import { accountAPI } from "services";
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const defaultValues = {
  name: "",
  phone: "",
  address: "",
  details: "",
  photo: { url: null, loading: false, file: null },
  tag: null
};


export const validatePhone = (value) => {
  if (!value) return true; // Phone is optional
  try {
    const isValid = phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
    return isValid || "Please enter a valid phone number";
  } catch (error) {
    return "Invalid phone number format";
  }
};

export const validateAccountName = async (value, accountId = null) => {
  if (!value) return "Name is required";
  
  if (accountId) {
    // For EditAccount - check if name changed
    const currentAccount = await accountAPI.getAccountById(accountId);
    if (currentAccount?.get("name") === value) return true;
  }
  
  // Check if name exists
  const accountByName = await accountAPI.getAccountByName(value);
  return !accountByName || "Account with this name already exists";
};
